import {
  taskStatusOptionsTranslation,
  TaskStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl';

export type TaskDialogTranslation = {
  button: {
    cancel: string;
    save: string;
  };
  confirmPastDate: {
    button: {
      cancel: string;
      confirm: string;
    };
    content: string;
    title: string;
  };
  form: {
    assignedUser: string;
    contextResourceType: string;
    description: string;
    dueDate: string;
    hidden: string;
    status: string;
    statusOptions: TaskStatusOptionsTranslation;
    title: string;
    watchedUserIds: string;
  };
  title: {
    create: string;
    update: string;
  };
};

export const taskDialogTranslation: TaskDialogTranslation = {
  button: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  confirmPastDate: {
    button: {
      cancel: 'Wróc',
      confirm: 'Zapisz',
    },
    content:
      'Wskazano przeszłą datę dla zadania. Potwierdź przez zapisaniem lub wróć, by poprawić.',
    title: 'Potwierdź datę zadania',
  },
  form: {
    assignedUser: 'Przypisany pracownik',
    contextResourceType: 'Typ zasobu',
    description: 'Opis',
    dueDate: 'Termin',
    hidden: 'Zadanie prywatne, widoczne wyłącznie dla twórcy i osoby przypisanej',
    status: 'Status',
    statusOptions: taskStatusOptionsTranslation,
    title: 'Tytuł',
    watchedUserIds: 'Obserwowujący',
  },
  title: {
    create: 'Utwórz zadanie',
    update: 'Aktualizuj zadanie',
  },
};
